export default __webpack_public_path__ + "assets/fonts/0f1c6040617e3739c2588e9e5d37ed7a.woff2";